// removed by extract-text-webpack-plugin
module.exports = {"root":"credit-summary--root--3C_QPq_D","container":"credit-summary--container--2knJ_LSb","content":"credit-summary--content--24vsIUKc","filters":"credit-summary--filters--4vNbrpof","background":"credit-summary--background--X3QsrUK3","chart":"credit-summary--chart--3lb1uoDB","transactions":"credit-summary--transactions--zyoRXNml"};


//////////////////
// WEBPACK FOOTER
// ./views/credit-summary/styles.css
// module id = ./views/credit-summary/styles.css
// module chunks = 0